var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"sys-btn text-no-wrap",style:({
    background: _vm.background,
    color: _vm.dark ? 'white' : undefined,
    padding: `${_vm.size + 2}px ${_vm.size + 7}px ${_vm.size + 1}px`,
  })},_vm.inputListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }